<template>
  <div>
    <v-sheet height="100%" color="black" tile
      ><v-container>
        <div class="pt-5 pb-5 h1">Featured Collection</div>
        <v-row align="center" justify="center">
          <v-col cols="12" md="4" lg="4" sm="6">
            <v-card class="mx-auto" max-width="250" color="white">
              <v-img
                src="@/assets/technology-partner.jpg"
                height="200px"
                class="inner-img"
              ></v-img>

              <div class="pl-3 pb-3 pr-3 pt-3">
                <h4 class="pt-3">
                  What are the most commonly asked questions for US visa
                  interview?
                </h4>
                <p>bt Y Sindhura posted at 6/13/22 12:07 PM</p>
                <p class="pt-2">Facing a visa interview can get</p>
                <p class="pt-2">quite unnerving for most of us.</p>
              </div>
              <div class="text-left pl-3 pb-3">
                <v-btn rounded color="green accent-4" dark>
                  <b>read more >> </b></v-btn
                >
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" lg="4" sm="6">
            <v-card class="mx-auto" max-width="250" color="white">
              <v-img
                src="@/assets/technology-partner.jpg"
                height="200px"
                class="inner-img"
              ></v-img>

              <div class="pl-3 pb-3 pr-3 pt-3">
                <h4 class="pt-3">
                  What are the most commonly asked questions for US visa
                  interview?
                </h4>
                <p>bt Y Sindhura posted at 6/13/22 12:07 PM</p>
                <p class="pt-2">Facing a visa interview can get</p>
                <p class="pt-2">quite unnerving for most of us.</p>
              </div>
              <div class="text-left pl-3 pb-3">
                <v-btn rounded color="green accent-4" dark>
                  <b>read more >> </b></v-btn
                >
              </div>
            </v-card></v-col
          >
          <v-col cols="12" md="4" lg="4" sm="6">
            <v-card class="mx-auto" max-width="250" color="white">
              <v-img
                src="@/assets/technology-partner.jpg"
                height="200px"
                class="inner-img"
              ></v-img>

              <div class="pl-3 pb-3 pr-3 pt-3">
                <h4 class="pt-3">
                  What are the most commonly asked questions for US visa
                  interview?
                </h4>
                <p>bt Y Sindhura posted at 6/13/22 12:07 PM</p>
                <p class="pt-2">Facing a visa interview can get</p>
                <p class="pt-2">quite unnerving for most of us.</p>
              </div>
              <div class="text-left pl-3 pb-3">
                <v-btn rounded color="green accent-4" dark>
                  <b>read more >> </b></v-btn
                >
              </div>
            </v-card></v-col
          >
        </v-row>
      </v-container>

      <div class="text-center pt-5">
        <v-btn color="green accent-4" dark large outlined>
          <b> More collection</b></v-btn
        >
      </div>
      <br />
    </v-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      colors: ["secondary", "secondary"],
      cycle: false,
    };
  },
};
</script>
<style scoped>
h4 {
  text-align: left;
  color: black;
}
.h1 {
  text-align: center;
  font-size: 40px;
  color: white;
}
h2 {
  color: black;
  text-align: center;
}
p {
  color: black;
  text-align: left;
  font-size: 12px;
  padding-top: 10px;
}

.inner-img {
  transition: 0.3s;
}

.inner-img:hover {
  transform: scale(0.9);
}

/* Other styling elements, that are not necessary for the example */
</style>